var map = {
	"./404.svg": "sEM+",
	"./alarm.svg": "mMjV",
	"./assesssvg.svg": "VG5g",
	"./batch.svg": "ccNl",
	"./box.svg": "N5kO",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./contact.svg": "9a2E",
	"./dashboard.svg": "BCGP",
	"./database.svg": "T380",
	"./dealer.svg": "gOOh",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fence.svg": "WBhp",
	"./filter.svg": "ObMl",
	"./form.svg": "sTIr",
	"./free.svg": "5Q/z",
	"./fullscreen.svg": "WIff",
	"./getOrder.svg": "kfgw",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./history.svg": "nTk5",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./logoff.svg": "xdKT",
	"./logout.svg": "KvOj",
	"./logs.svg": "49QO",
	"./mail.svg": "CFfD",
	"./message.svg": "G2zY",
	"./mobile.svg": "ofrD",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./news.svg": "zgXw",
	"./order.svg": "gYtG",
	"./orderTracking.svg": "Ellx",
	"./outOfStock.svg": "iQbp",
	"./page.svg": "zrC5",
	"./password.svg": "QjmH",
	"./paycheck.svg": "+Mec",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./reject.svg": "Mql9",
	"./replace.svg": "c2f9",
	"./safe.svg": "1Bju",
	"./search.svg": "Bx0U",
	"./setting.svg": "Kttn",
	"./shopping.svg": "jRi0",
	"./sign.svg": "HE8u",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./stock.svg": "t+aG",
	"./tab.svg": "Jysk",
	"./table-setting.svg": "hTsv",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./transport.svg": "EGRk",
	"./tree.svg": "3eCm",
	"./truck.svg": "3Kjf",
	"./user.svg": "VdD3",
	"./warehouse.svg": "BupX",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 171